// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-table__head th {\n  font-family: var(--interfaceFontTypeface, inherit);\n  font-weight: var(--interfaceFontWeight, inherit);\n  color: var(--interfaceFontColor, inherit);\n}\n.base-table__body td a {\n  font-family: var(--interfaceFontTypeface, inherit);\n  font-weight: var(--interfaceFontWeight, inherit);\n  color: var(--interfaceFontColor, inherit);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
